import "core-js/modules/es.array.concat.js";
import playground from './modules/playground';
import plugins from './modules/plugins';
import components from './modules/components';
import layoutHeaderAside from '@/layout/header-aside'; // 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载

var _import = require('@/libs/util.import.' + process.env.NODE_ENV);
/**
 * 在主框架内显示
 */


var frameIn = [{
  path: '/',
  redirect: {
    name: 'index'
  },
  component: layoutHeaderAside,
  children: [// 首页
  {
    path: '/index',
    name: 'index',
    meta: {
      title: '首页',
      auth: true
    },
    component: _import('system/index')
  }, {
    path: '/DeliveryNote/MaintainDeliveryNote2',
    name: 'MaintainDeliveryNote2',
    meta: {
      title: '新增/维护送货单',
      auth: true,
      parent: '供应商'
    },
    component: _import('DeliveryNote/MaintainDeliveryNote2')
  }, {
    path: '/DeliveryNote/Outsourced',
    name: 'Outsourced',
    meta: {
      title: '新增/维护委外送货单',
      auth: true,
      parent: '供应商'
    },
    component: _import('DeliveryNote/Outsourced')
  }, {
    path: '/DeliveryNote/DeliveryDetailsQuery',
    name: 'DeliveryDetailsQuery',
    meta: {
      title: '送货明细报表',
      auth: true,
      parent: '报表中心'
    },
    component: _import('DeliveryNote/DeliveryDetailsQuery')
  }, {
    path: '/DeliveryNote/PurchaseOrderReport',
    name: 'PurchaseOrderReport',
    meta: {
      title: '采购订单报表',
      auth: true,
      parent: '报表中心'
    },
    component: _import('DeliveryNote/PurchaseOrderReport')
  }, {
    path: '/DeliveryNote/OutsourcingOrderReport',
    name: 'OutsourcingOrderReport',
    meta: {
      title: '委外订单报表',
      auth: true,
      parent: '报表中心'
    },
    component: _import('DeliveryNote/OutsourcingOrderReport')
  }, {
    path: '/DeliveryNote/DeliveryCode',
    name: 'DeliveryCode',
    meta: {
      title: '内箱标签管理',
      auth: true,
      parent: '供应商'
    },
    // component: _import('DeliveryNote/DeliveryCode')
    component: _import('DeliveryNote/DeliveryCode_v2')
  }, {
    path: '/DeliveryNote/OuterBoxLabelManagement',
    name: 'OuterBoxLabelManagement',
    meta: {
      title: '外箱标签管理',
      auth: true,
      parent: '供应商'
    },
    // component: _import('DeliveryNote/OuterBoxLabelManagement')
    component: _import('DeliveryNote/OuterBoxLabelManagement_v2')
  }, {
    path: '/DeliveryNote/DnbarcodeHandmade',
    name: 'DnbarcodeHandmade',
    meta: {
      title: '手工打码（内箱）',
      auth: true,
      parent: '供应商'
    },
    component: _import('DeliveryNote/DnbarcodeHandmade')
  }, {
    path: '/DeliveryNote/DnbarcodeHandmadeOutBox',
    name: 'DnbarcodeHandmadeOutBox',
    meta: {
      title: '手工打码（外箱）',
      auth: true,
      parent: '供应商'
    },
    component: _import('DeliveryNote/DnbarcodeHandmadeOutBox')
  }, {
    path: '/DeliveryNote/SubDeliveryNote',
    name: 'SubDeliveryNote',
    meta: {
      title: '下游供应商送货单',
      auth: true,
      parent: '供应商'
    },
    component: _import('DeliveryNote/SubDeliveryNote')
  }, {
    path: '/System/User',
    name: 'User',
    meta: {
      title: '采购员账号管理',
      auth: true,
      parent: '系统管理'
    },
    component: _import('system/User')
  }, {
    path: '/System/Vender',
    name: 'Vender',
    meta: {
      title: '供应商账号管理',
      auth: true,
      parent: '系统管理'
    },
    component: _import('system/Vender')
  }, {
    path: '/System/Role',
    name: 'Role',
    meta: {
      title: '角色管理',
      auth: true,
      parent: '系统管理'
    },
    component: _import('ManagerRole/index')
  }, // {
  //   path: '/Manager/Index',
  //   name: 'Manager',
  //   meta: {
  //     title: '用户管理',
  //     auth: true
  //   },
  //   component: _import('Manager/index')
  // },
  {
    path: '/Menu/Index',
    name: 'Menu',
    meta: {
      title: '菜单管理',
      auth: true,
      parent: '系统管理'
    },
    component: _import('Menu/Index')
  }, {
    path: '/Portal/Announcement',
    name: 'Announcement',
    meta: {
      title: '公告/须知',
      auth: true,
      parent: '公告管理'
    },
    component: _import('Portal/Announcement')
  }, {
    path: '/SysReportTpl/Index',
    name: 'SysReportTpl',
    meta: {
      title: '单据打印模板',
      auth: true,
      parent: '系统管理'
    },
    component: _import('SysReportTpl/Index')
  }, {
    path: '/System/Mail',
    name: 'Mail',
    meta: {
      title: '邮件服务设置',
      auth: true,
      parent: '系统管理'
    },
    component: _import('system/Mail')
  }, {
    path: '/System/ExportRecord',
    name: 'ExportRecord',
    meta: {
      title: '数据导出记录',
      auth: true,
      parent: '系统管理'
    },
    component: _import('system/ExportRecord')
  }, // 系统 前端日志
  {
    path: 'log',
    name: 'log',
    meta: {
      title: '前端日志',
      auth: true
    },
    component: _import('system/log')
  } // 刷新页面 必须保留
  // {
  //   path: 'refresh',
  //   name: 'refresh',
  //   hidden: true,
  //   component: _import('system/function/refresh')
  // },
  // // 页面重定向 必须保留
  // {
  //   path: 'redirect/:route*',
  //   name: 'redirect',
  //   hidden: true,
  //   component: _import('system/function/redirect')
  // }
  ]
} // playground,
// plugins,
// components
];
/**
 * 在主框架之外显示
 */

var frameOut = [// 登录
{
  path: '/login',
  name: 'login',
  component: _import('system/login')
}];
/**
 * 错误页面
 */

var errorPage = [{
  path: '*',
  name: '404',
  component: _import('system/error/404')
}]; // 导出需要显示菜单的

export var frameInRoutes = frameIn; // 重新组织后导出

export default [].concat(frameIn, frameOut, errorPage);